var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3577_53719)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3577_53719)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.37148,
    cy: 8.00136,
    r: 5.56679,
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1152 7.62598H14.7402V8.37598H15.1152V7.62598ZM15.9408 8.37598C16.1479 8.37598 16.3158 8.20808 16.3158 8.00098C16.3158 7.79387 16.1479 7.62598 15.9408 7.62598V8.37598ZM15.1152 8.37598H15.9408V7.62598H15.1152V8.37598Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.62892 7.62598H2.00392V8.37598H1.62892V7.62598ZM0.803387 8.37598C0.59628 8.37598 0.428387 8.20808 0.428387 8.00098C0.428387 7.79387 0.59628 7.62598 0.803387 7.62598V8.37598ZM1.62892 8.37598H0.803387V7.62598H1.62892V8.37598Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74658 14.7441L8.74658 14.3691L7.99658 14.3691L7.99658 14.7441L8.74658 14.7441ZM7.99658 15.5697C7.99658 15.7768 8.16448 15.9447 8.37158 15.9447C8.57869 15.9447 8.74658 15.7768 8.74658 15.5697L7.99658 15.5697ZM7.99658 14.7441L7.99658 15.5697L8.74658 15.5697L8.74658 14.7441L7.99658 14.7441Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74658 1.25685L8.74658 1.63185L7.99658 1.63185L7.99658 1.25685L8.74658 1.25685ZM7.99658 0.431317C7.99658 0.22421 8.16448 0.0563168 8.37158 0.0563169C8.57869 0.0563169 8.74658 0.22421 8.74658 0.431317L7.99658 0.431317ZM7.99658 1.25685L7.99658 0.431317L8.74658 0.431317L8.74658 1.25685L7.99658 1.25685Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.37172,
    cy: 8.00112,
    r: 4.0519,
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37163 5.13915L6.32237 9.75L8.37163 8.68592L10.4209 9.75L8.37163 5.13915Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3577_53719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16.3716 16) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3577_53719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.371582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsOutline);
export default __webpack_public_path__ + "static/media/gps-outline.0e477b2e889d5c92e836bceff2ee1677.svg";
export { ForwardRef as ReactComponent };